export const tokenKey = `token`;

export function useToken() {
  const sessionToken = sessionStorage.getItem(tokenKey);
  const initialParams = new URLSearchParams(location.search);
  const URLToken = initialParams.get(tokenKey);

  const setToken = (newToken: string | null) => {
    if (newToken === null) {
      sessionStorage.removeItem(tokenKey);
    } else {
      sessionStorage.setItem(tokenKey, newToken);
    }
  };

  return {
    sessionToken,
    URLToken,
    setToken,
  };
}
